import { task } from 'mobx-task'
import type { GetCurrentUserWorkspaceMembershipsFn } from '@/features/iam'
import { type WorkspacePostingStore } from '@/features/admin/staffing/WorkspacePostingStore'
import type { AlertErrorHandlerFactory, AlertFactory } from '@/features/shell'
import { WorkspacePostingDialogViewModel } from '@/features/admin/staffing/components/WorkspacePostingDialog/WorkspacePostingDialogViewModel'

export class CreateWorkspacePostingDialogViewModel extends WorkspacePostingDialogViewModel {
  constructor(
    private readonly _workspacePostingStore: WorkspacePostingStore,
    private readonly _newAlert: AlertFactory,
    private readonly _createAlertErrorHandler: AlertErrorHandlerFactory,
    private readonly _refreshStatusFilter: () => Promise<void>,
    getWorkspaceMemberships: GetCurrentUserWorkspaceMembershipsFn,
  ) {
    super(getWorkspaceMemberships)
  }

  /**
   * Create a workspace posting.
   */
  submit = task.resolved(async () => {
    if (!this.validate()) {
      return
    }

    await this._workspacePostingStore
      .createWorkspacePosting(this.workspace?.id, {
        ...this.details,
        opportunityType: this.opportunityType,
      })
      .catch(this._createAlertErrorHandler('Creating the posting failed'))

    void this._refreshStatusFilter()
    this._newAlert()
      .withState('success')
      .saying('Success', 'Workspace posting created.')
      .autoDismiss()
      .show()
    this.close()
  })
}
